import React from 'react';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';

export default function Pagination({ pagination, onPageChange }) {
  const { page, pages } = pagination;

  if (pages <= 1) return null;

  const renderPageNumbers = () => {
    const items = [];
    const maxVisible = 5;

    // Logic to show a window of pages
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(pages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    if (start > 1) {
      items.push(1);
      if (start > 2) items.push('...');
    }

    for (let i = start; i <= end; i++) {
      items.push(i);
    }

    if (end < pages) {
      if (end < pages - 1) items.push('...');
      items.push(pages);
    }

    return items.map((item, idx) => (
      item === '...' ? (
        <span key={`dots-${idx}`} className="page-dots">...</span>
      ) : (
        <button
          key={item}
          className={`page-btn ${page === item ? 'active' : ''}`}
          onClick={() => onPageChange(item)}
        >
          {item}
        </button>
      )
    ));
  };

  return (
    <div className="pagination">
      <button 
        className="page-btn" 
        disabled={page === 1}
        onClick={() => onPageChange(page - 1)}
      >
        <MdChevronLeft size={20} />
      </button>
      
      {renderPageNumbers()}

      <button 
        className="page-btn" 
        disabled={page === pages}
        onClick={() => onPageChange(page + 1)}
      >
        <MdChevronRight size={20} />
      </button>
    </div>
  );
}
